import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";
import { useEffectiveCompanyId } from "hooks/useEffectiveCompanyId";

export function useRerunnerConfigs() {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [featureGated, setFeatureGated] = useState(false);

  const { user } = useAuth();

  const companyId = useEffectiveCompanyId();

  const fetchConfigs = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    setFeatureGated(false);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getRerunnerConfigs,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setConfigs(res.data?.data ?? res.data ?? []);
    } catch (err) {
      const msg =
        err?.response?.data?.error || err?.response?.data?.message || "";
      if (err?.response?.status === 403 && msg.toLowerCase().includes("feature")) {
        setFeatureGated(true);
      } else {
        setError(err);
      }
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchConfigs();
  }, [fetchConfigs]);

  return { configs, loading, error, featureGated, refetch: fetchConfigs };
}
